// extracted by mini-css-extract-plugin
export default {"inputLayout":"styles_inputLayout__PneM+","inputBoxLayout":"styles_inputBoxLayout__GskYB"};